import { Metric } from "../Metric"

export interface FlushMetric extends Metric {
  flush(): Metric
}

export function isFlushMetric(metric: Metric): metric is FlushMetric {
  return typeof (metric as any).flush !== "undefined" && typeof (metric as any).flush === "function"
}
